import React from "react";

interface BreadcrumbItem {
  label: string;
  href?: string; 
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <div className="page-title shop-page-title product-page-title">
      <div className="page-title-inner flex-row medium-flex-wrap container">
        <div className="flex-col flex-grow medium-text-center">
          <div className="is-large">
            <nav
              className="woocommerce-breadcrumb breadcrumbs"
              aria-label="Breadcrumb"
            >
              {items.map((item, index) => {
                const isLast = index === items.length - 1;

                return (
                  <React.Fragment key={index}>
                    {!isLast ? (
                      <a href={item.href}>{item.label}</a>
                    ) : (
                      <span>{item.label}</span>
                    )}
                    {!isLast && <span className="divider">/</span>}
                  </React.Fragment>
                );
              })}
            </nav>
          </div>
        </div>
        <div className="flex-col medium-text-center"></div>
      </div>
    </div>
  );
}
